<template>
  <div class="container">
    <h2>updated landing</h2>
    {{ landingPages }}
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      landingPages: [],
    }
  },
  created() {
    this.Loaded()
    axios
      .get('https://isaservice.upskill.com.bd/user/landing/all')
      .then((res) => {
        this.landingPages = res.data.data
      })
  },
}
</script>

<style></style>
